import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export const deleteSkill = async (skillId: string): Promise<void> => {
  const { currentOrg } = useOrgStore.getState();
  const orgId = currentOrg?.orgid;
  if (!orgId) throw new Error('No organization selected');

  const response = await apiRequest({
    url: `/skills/${orgId}/${skillId}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }
};
